import { Controller } from "@hotwired/stimulus"

// Shows the cookie-consent banner when no decision is stored, and persists
// the visitor's choice via window.StokedConsent (app/javascript/consent.js),
// which releases the queued tracker loaders. Any element on the page with a
// [data-consent-open] attribute (e.g. the footer "Cookie preferences" link)
// reopens the banner.
export default class extends Controller {
  static targets = ["analyticsToggle", "marketingToggle"]

  connect() {
    this.openHandler = (event) => {
      if (!event.target.closest("[data-consent-open]")) return
      event.preventDefault()
      this.open()
    }
    document.addEventListener("click", this.openHandler)

    if (!window.StokedConsent?.get()) this.open()
  }

  disconnect() {
    document.removeEventListener("click", this.openHandler)
  }

  open() {
    const state = window.StokedConsent?.get()
    if (this.hasAnalyticsToggleTarget) {
      this.analyticsToggleTarget.checked = state ? state.analytics : true
    }
    if (this.hasMarketingToggleTarget) {
      this.marketingToggleTarget.checked = state ? state.marketing : true
    }
    this.element.hidden = false
  }

  acceptAll() {
    this.#apply(true, true)
  }

  declineAll() {
    this.#apply(false, false)
  }

  save() {
    this.#apply(
      this.hasAnalyticsToggleTarget && this.analyticsToggleTarget.checked,
      this.hasMarketingToggleTarget && this.marketingToggleTarget.checked,
    )
  }

  #apply(analytics, marketing) {
    window.StokedConsent.set({ analytics, marketing })
    this.element.hidden = true
  }
}
